import {Component, Inject, OnInit} from '@angular/core';
import {FormGroup, ValidatorFn, Validators} from "@angular/forms";

@Component({
  selector: 'app-select-metric',
  templateUrl: './setting-metric.component.html',
  styleUrls: ['./setting-metric.component.scss']
})
export class SettingMetricComponent implements OnInit {

  public form: FormGroup = this.params.form;
  public validators: Array<ValidatorFn> = [Validators.required];

  constructor(
    @Inject('formInjector') public params: any
  ) {
  }

  ngOnInit(): void {
    this.params.stepForm.addControl('metric', this.params.form.get('metric'));
  }

}
